import { useEffect, useState } from "react";
import { createContext } from "react";
import axios from 'axios';
import { useContext } from "react";

const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
})

const gameContext = createContext()

export function GameProvider({ children }) {
    const [industriesBase, setIndustries] = useState(null)
    const [activeGame, setActiveGame] = useState([])
    const [allGames, setAllGames] = useState([])

    async function fetchActiveGame() {
        try {
            const response = await api.get("/api/jogo/obterJogoAtivo")
            setActiveGame(response.data)
        } catch (error) {
            console.log(error)
        }
    }

    async function fetchAllGames() {
        try {
            const response = await api.get("/api/jogo/listarTodos")
            setAllGames(response.data)
        } catch (error) {
            console.log(error)
        }
    }

    async function fetchIndustries() {
        try {
          api.get(`/api/industria/listarBase`)
            .then(response => setIndustries(response.data))
        } catch (error) {
          console.log(error)
        }
      }

    useEffect(() => {
        setActiveGame({})
        fetchActiveGame()
        fetchAllGames()
        fetchIndustries()
    }, [])

    return (
        <gameContext.Provider
            value={{
                activeGame,
                allGames,
                industriesBase
            }}
        >
            {children}
        </gameContext.Provider>
    )
}

export const useGame = () => useContext(gameContext);